import React, {Component} from 'react'
import {InfoDialog} from 'components/InfoDialog'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import StyleSheet from 'styles'
import {FormattedMessage} from 'react-intl'

export class BankAccountInvest extends Component {
  state = {
    addressOpen: false
  }

  render() {
    const {allocation, allocation: {paymentDestination: bankAccount, currency}} = this.props
    return (
      <div style={{margin: '20px 10px'}}>
        <Button style={{width: '100%'}}
          variant="contained"
          color='primary'
          onClick={() => this.setState({addressOpen: true})}
        >
          <FormattedMessage id="bank_account.pay.title" />
        </Button>
        <InfoDialog
          onClose={() => this.setState({addressOpen: false})}
          title="Payment Instructions"
          open={this.state.addressOpen}
        >
          <Typography><FormattedMessage id="bank_account.pay.instructions" /></Typography>

          <dl className={styles.accountDetails}>
            <dt><FormattedMessage id="bank_account.pay.amount_label" /></dt>
            <dd>{currency.prefix}{allocation.paymentExpected} {currency.code}</dd>
            <dt><FormattedMessage id="bank_account.bank_name_label" /></dt>
            <dd>{bankAccount.bankName}</dd>
            <dt><FormattedMessage id="bank_account.bank_address_label" /></dt>
            <dd>{bankAccount.bankAddress}</dd>
            <dt><FormattedMessage id="bank_account.swift_code_label" /></dt>
            <dd>{bankAccount.swiftCode}</dd>
            <dt><FormattedMessage id="bank_account.account_name_label" /></dt>
            <dd>{bankAccount.accountName}</dd>
            <dt><FormattedMessage id="bank_account.account_bsb_label" /></dt>
            <dd>{bankAccount.accountBsb}</dd>
            <dt><FormattedMessage id="bank_account.account_number_label" /></dt>
            <dd>{bankAccount.accountNumber}</dd>
            <dt><FormattedMessage id="bank_account.payee_name_label" /></dt>
            <dd>{bankAccount.payeeName}</dd>
            <dt><FormattedMessage id="bank_account.payee_address_label" /></dt>
            <dd>{bankAccount.payeeAddress}</dd>
            <dt><FormattedMessage id="bank_account.bank_reference_label" /></dt>
            <dd>{allocation.bankReference}</dd>
          </dl>

          <Typography><FormattedMessage id="bank_account.destination_address_label" />: {allocation.tokenDestinationAddress}</Typography>
        </InfoDialog>
      </div>
    )
  }
}

const styles = StyleSheet({
  accountDetails: {
    '& dt': {
      fontWeight: 'bold',
      marginBottom: 5
    },
    '& dd': {
      marginLeft: 0,
      marginBottom: 10
    }
  }
})